// app/components/AdvancedChart/utils/syncTimeScale.ts
import { IChartApi } from 'lightweight-charts'

export function syncTimeScale(
  chartA: IChartApi | null,
  chartB: IChartApi | null
) {
  if (!chartA || !chartB) return
  const tsA = chartA.timeScale()
  const tsB = chartB.timeScale()
  let isSyncingA = false
  let isSyncingB = false

  tsA.subscribeVisibleLogicalRangeChange(range => {
    if (isSyncingB || !range) return
    isSyncingA = true
    tsB.setVisibleLogicalRange(range)
    isSyncingA = false
  })

  tsB.subscribeVisibleLogicalRangeChange(range => {
    if (isSyncingA || !range) return
    isSyncingB = true
    tsA.setVisibleLogicalRange(range)
    isSyncingB = false
  })
}
